import React from "react";
import { useEffect } from "react";
import Kembali from "../../components/Pengembalian/Kembali";

const Pengembalian = () => {
  useEffect(() => {
    document.title = "Si TASIK - Pengembalian";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <Kembali/>
    </div>
  );
};

export default Pengembalian;
